import React, { useContext, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import ModuleContext from '../../../CMFW/context/ModuleContext';
import SentenceModel from '../../../models/SentenceModel';
import { useForceRender } from '../../../hooks/useForceRender';
import { ListDialects } from '../../../CMFW/layout/ListDialects';
import Label from '../../../CMFW/input/Label';
import CATModel from '../../../models/CATModel';
import CircularProgress from '@material-ui/core/CircularProgress';

export type IProps = {};

const CATContextSentence: React.FC<IProps> = () => {
  const forceRender = useForceRender();
  const module = useContext(ModuleContext) as CATModel;
  const sentenceModel = useMemo(() => new SentenceModel({ render: forceRender, courseId: module.courseId }), [
    forceRender,
    module.courseId,
  ]);

  const active = module.getActive();

  useEffect(() => {
    if (active) {
      sentenceModel.loadItemEdit(active.contextItemId);
    }
  }, [sentenceModel, active]);

  if (active === null) {
    return null;
  } else if (sentenceModel.loadingItem) {
    return (
      <Wrapper>
        <CircularProgress size={10} />
      </Wrapper>
    );
  } else {
    return (
      <ModuleContext.Provider value={sentenceModel}>
        <Wrapper>
          <Info>Read by: {sentenceModel.getItemValue('readby')}</Info>
          <ListDialects keyName={'sources'} narrow>
            <Label keyName={'text'} />
          </ListDialects>
        </Wrapper>
      </ModuleContext.Provider>
    );
  }
};

export default CATContextSentence;

const Wrapper = styled.div`
  margin: 4px;
  font-size: 14px !important;
  white-space: pre-wrap;
`;

const Info = styled.p`
  margin: 0;
`;
